// This component is not used anywhere. CH-8237
import React, { useState, Fragment } from "react";
import styled from "styled-components";

import { setMetropolitanStatisticalArea, setMetropolitanStatisticalAreaHCP } from "./api";
import { SelectMSA } from "./selectMSA";
import { showErrorToast } from "@src/appV2/lib/Notifications";

const Label = styled.label`
  margin-right: 10px;
`;

function SelectMetropolitanStatisticalArea({
  facilityId,
  agentId,
  defaultMetropolitanStatisticalArea,
}) {
  const [selectedMetropolitanStatisticalArea, setSelectedMetropolitanStatisticalArea] = useState(
    defaultMetropolitanStatisticalArea
  );

  const onMetropolitanStatisticalAreaChange = async (newMetropolitanStatisticalArea) => {
    try {
      if (facilityId) {
        await setMetropolitanStatisticalArea(facilityId, newMetropolitanStatisticalArea);
      } else {
        await setMetropolitanStatisticalAreaHCP(agentId, newMetropolitanStatisticalArea);
      }

      setSelectedMetropolitanStatisticalArea(newMetropolitanStatisticalArea);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
      showErrorToast("The Metropolitan Statistical Area could not be changed. Please try again.");
    }
  };

  return (
    <Fragment>
      <Label>MSA</Label>
      <SelectMSA
        onChange={onMetropolitanStatisticalAreaChange}
        value={selectedMetropolitanStatisticalArea}
        disabled={false}
      ></SelectMSA>
    </Fragment>
  );
}

export default SelectMetropolitanStatisticalArea;
